import binIcon from '@src/main/assets/icons/bin.svg';
import { Button } from 'primereact/button';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './DeleteButton.module.scss';

interface Props {
  onClick: () => void;
  loading?: boolean;
}

export const DeleteButton: FC<Props> = ({ onClick, loading }) => {
  const { t } = useTranslation();
  return (
    <Button
      label={t('common.delete')}
      icon={<img src={binIcon} alt={t('common.delete')} width="15" />}
      className={styles.button}
      onClick={onClick}
      loading={loading}
    />
  );
};
